// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".restaurant-detail[data-v-a0fad74c]{font-size:1.125rem}h3[data-v-a0fad74c]{color:#e70095;font-size:1.5rem;font-weight:700}[data-v-a0fad74c] p:last-child{margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
